module.exports = __webpack_public_path__ + "img/appstore.e36d885a.png";